import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';

export type SignupPageContextProps = {
  privacyPolicyText?: string;
  setPrivacyPolicyText: (text: string) => void;
};

export const SignupPageContext = createContext<SignupPageContextProps | null>(null);

export const useSignupPageContext = (): SignupPageContextProps => {
  const context = useContext(SignupPageContext);

  if (!context) {
    throw new Error('useSignupPageContext must be used within a SignupPageContextProvider');
  }

  return context;
};

type SignupPageProviderProps = {
  children: ReactNode;
};

export const SignupPageContextProvider = ({ children }: SignupPageProviderProps) => {
  const [privacyPolicyText, setPrivacyPolicyText] = useState<undefined | string>();

  const state = useMemo(
    (): SignupPageContextProps => ({
      privacyPolicyText,
      setPrivacyPolicyText,
    }),
    [privacyPolicyText, setPrivacyPolicyText]
  );

  return <SignupPageContext.Provider value={state}>{children}</SignupPageContext.Provider>;
};
